import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import UserServices from './adminServices';

export const CreateUser = createAsyncThunk(
  'admin/createAdmin',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await UserServices.CreateUser(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const FetchAdminUsers = createAsyncThunk(
  'admin/fetchAdminUsers',
  async (payload, thunkAPI) => {
    try {
      let response = await UserServices.getAllAdminDetails(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const FetchAdminUsersAdvance = createAsyncThunk(
  'admin/fetchAdminUsers_advanced',
  async (payload, thunkAPI) => {
    try {
      let response = await UserServices.getAllAdminDetails(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const DeleteAdmin = createAsyncThunk(
  'admin/deleteUser',
  async (payload, thunkAPI) => {
    try {
      let response = await UserServices.DeleteAdmin(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UploadProfileImage = createAsyncThunk(
  'admin/uploadProfile',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await UserServices.uploadProfileImage(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const EditAdmin = createAsyncThunk(
  'auth/edit_admin',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await UserServices.editUserFromAdmin(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);
